/**
 * @generated SignedSource<<21536f9084d31d6afad3148c279ee98c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileSectionAuctions_viewer$data = {
  readonly nftsForSale: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly metadata: {
          readonly name?: string | null;
        } | null;
        readonly mostRecentAuction: {
          readonly " $fragmentSpreads": FragmentRefs<"NftItemTile_nftAuction">;
        } | null;
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"NftItemTile_nftItem">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftHeartPillProvider_viewer" | "NftItemTile_viewer">;
  readonly " $fragmentType": "NftProfileSectionAuctions_viewer";
};
export type NftProfileSectionAuctions_viewer$key = {
  readonly " $data"?: NftProfileSectionAuctions_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileSectionAuctions_viewer">;
};

import NftProfileSectionAuctionsPaginationQuery_graphql from './NftProfileSectionAuctionsPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "nftsForSale"
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "liveAuctionsCursor"
    },
    {
      "kind": "RootArgument",
      "name": "liveAuctionsFirst"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "kind": "RootArgument",
      "name": "username"
    },
    {
      "kind": "RootArgument",
      "name": "walletAddress"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "liveAuctionsFirst",
        "cursor": "liveAuctionsCursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "liveAuctionsFirst",
          "cursor": "liveAuctionsCursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": NftProfileSectionAuctionsPaginationQuery_graphql
    }
  },
  "name": "NftProfileSectionAuctions_viewer",
  "selections": [
    {
      "alias": "nftsForSale",
      "args": [
        {
          "items": [
            {
              "kind": "Variable",
              "name": "auctionSellerAddresses.0",
              "variableName": "walletAddress"
            }
          ],
          "kind": "ListValue",
          "name": "auctionSellerAddresses"
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "auctionSellerProfileUsernames.0",
              "variableName": "username"
            }
          ],
          "kind": "ListValue",
          "name": "auctionSellerProfileUsernames"
        },
        {
          "kind": "Literal",
          "name": "excludeOwnerCreatedItems",
          "value": true
        }
      ],
      "concreteType": "NftItemSearchConnection",
      "kind": "LinkedField",
      "name": "__NftProfileSectionAuctions_nftsForSale_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NftItemSearchEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NftItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "metadata",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "type": "NftDigitalArtMetadata",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "excludeCanceled",
                      "value": true
                    }
                  ],
                  "concreteType": "NftAuction",
                  "kind": "LinkedField",
                  "name": "mostRecentAuction",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "NftItemTile_nftAuction"
                    }
                  ],
                  "storageKey": "mostRecentAuction(excludeCanceled:true)"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NftItemTile_nftItem"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftHeartPillProvider_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTile_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "b1140e2b97e6141efb0bbc95bd447c36";

export default node;
